// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__sUyL4","itemTitle":"ClientEmergencyInfo_itemTitle__2MeJE","itemText":"ClientEmergencyInfo_itemText__bVu78"};